/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRequesterRequest } from '../models/CreateRequesterRequest';
import type { PagedRequesters } from '../models/PagedRequesters';
import type { Requester } from '../models/Requester';
import type { UpdateRequesterRequest } from '../models/UpdateRequesterRequest';
import { request as __request } from '../core/request';

export class RequestersService {

    /**
     * Search for requesters
     * @returns PagedRequesters Success
     * @throws ApiError
     */
    public static async getRequesters({
query,
page = '0',
pageSize = '30',
}: {
/** Search term **/
query?: string,
/** Page number **/
page?: string,
/** Page size **/
pageSize?: string,
}): Promise<PagedRequesters> {
        const result = await __request({
            method: 'GET',
            path: `/requesters/`,
            query: {
                'query': query,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Create (or restore) a new Requester
     * @returns Requester Success
     * @throws ApiError
     */
    public static async postRequesters({
requestBody,
}: {
requestBody: CreateRequesterRequest,
}): Promise<Requester> {
        const result = await __request({
            method: 'POST',
            path: `/requesters/`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Get existing Requester
     * @returns Requester Success
     * @throws ApiError
     */
    public static async getRequesterByToken({
token,
}: {
token: string,
}): Promise<Requester> {
        const result = await __request({
            method: 'GET',
            path: `/requesters/${token}`,
            errors: {
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Delete existing Requester
     * @returns void 
     * @throws ApiError
     */
    public static async deleteRequesterByToken({
token,
}: {
token: string,
}): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/requesters/${token}`,
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Update existing Requester
     * @returns Requester Success
     * @throws ApiError
     */
    public static async patchRequesterByToken({
token,
requestBody,
}: {
token: string,
requestBody: UpdateRequesterRequest,
}): Promise<Requester> {
        const result = await __request({
            method: 'PATCH',
            path: `/requesters/${token}`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

}